import { render, staticRenderFns } from "./_code.vue?vue&type=template&id=bce8e222&scoped=true&"
import script from "./_code.vue?vue&type=script&lang=js&"
export * from "./_code.vue?vue&type=script&lang=js&"
import style0 from "./_code.vue?vue&type=style&index=0&id=bce8e222&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce8e222",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/Loading.vue').default})
